module.exports = "\r\n\r\n.panel {\r\n  border: 1px solid #d1d6e6;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/event-components/edit-notification-event/edit-notification-event.component.css
// module id = ./src/app/event-components/edit-notification-event/edit-notification-event.component.css
// module chunks = main